module.exports = __webpack_public_path__ + "img/SummaryBannerMobile.0adda6ad.svg";